import { Pipe, PipeTransform } from '@angular/core';
import { AppConstants } from '@core-lib/config';
import { IDevise } from '@core-lib/models';

@Pipe({
    name: 'amount',
    standalone: false
})
export class AmountPipe implements PipeTransform {
	config = AppConstants.CURRENCY_MASK_OPTIONS;

	transform(value: number, devise?: IDevise, thousandsConfig?: string, nombreDecimales?: number): string {
		if (typeof value !== 'number') {
			return '';
		}
		
		let formattedValue: string = value.toFixed(nombreDecimales ? nombreDecimales : this.config.precision);

		const parts = formattedValue.split('.');

		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsConfig ?? this.config.thousands);

		formattedValue = `${parts.join(this.config.decimal)} ${devise ? devise.codeISO : ''}`;

		return formattedValue;
	}
}
